// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login__container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 30px;
  padding: 5% 0;
}

/* ============= Login Form ============= */
.login__form__login {
  width: 40%;
  background: #fff;
  box-shadow: 0px 0px 73.6px 0px rgba(42, 77, 114, 0.19);
  border-radius: 30px;
  padding: 57px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  border: 2px solid transparent;
  transition: all 0.15s ease-in-out;
}

.login__form__login:focus-within {
  border: 2px solid #0c6b60;
}

.login__form__login > h1 {
  inline-size: 100%;
  color: #777f87;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
}

.login__form__login > div {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Border, #dde1eb);
  background: var(--White, #fff);
  overflow: hidden;
  padding: 0 16px;
}

.login__form__login > div > input {
  flex: 1 1;
  height: 100%;
  border: none;
  outline: none;

  color: #434343;
  font-size: 16px;
  font-weight: 500;
}

.login__form__login > div > input::placeholder {
  color: var(--Placeholder, #b2bac6);
}

.login__form__login > div > span {
  display: flex;
  cursor: pointer;
}

.login__form__login > div > span > svg {
  font-size: 18px;
}

.login__form__login > button {
  width: 166px;
  height: 45px;
  border-radius: 8px;
  background: #0c6b60;
  border: none;
  cursor: pointer;

  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
}

.login__form__login > a {
  color: #a2a2a2;
  font-size: 12px;
  font-weight: 400;
  text-decoration-line: underline;
}

/* ========== Registration form ============ */
.login__form__registration {
  width: calc(60% - 30px);
  border-radius: 30px;
  border: 2px solid transparent;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  box-shadow: 0px 0px 73.6px 0px rgba(42, 77, 114, 0.19);
  transition: all 0.15s ease-in-out;
}

.login__form__registration:focus-within {
  border: 2px solid #0c6b60;
}

.login__form__registration > h1 {
  color: #777f87;
  font-size: 24px;
  font-weight: 600;
  text-transform: uppercase;
}

.login__form__registration__actions {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
}

.login__form__registration__actions > label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.login__form__registration__actions > label > b {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1.2px solid var(--Gray, #a0a8b5);
  background: var(--White, #fff);
}

.login__form__registration__actions > label > input:checked + b {
  border: 5px solid #0c6b60;
}

.reg__manager {
  max-width: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.reg__manager > div {
  width: 100%;
  display: flex;
  gap: 10px;
}

.reg__manager > :where(input, div) {
  width: 100%;
  height: 45px;
  border-radius: 8px;
  border: 1px solid var(--Border, #dde1eb);
  background: var(--White, #fff);
  padding: 0 16px;
  outline: none;

  color: #434343;
  font-size: 16px;
  font-weight: 500;
}

.reg__manager > input::placeholder {
  color: var(--Placeholder, #b2bac6);
}

.reg__manager > div {
  display: flex;
  align-items: center;
}

.reg__manager > div > input {
  flex: 1 1;
  height: 100%;
  border: none;

  color: #434343;
  font-size: 16px;
  font-weight: 500;
}

.reg__manager > div > input::placeholder {
  color: var(--Placeholder, #b2bac6);
}

.reg__manager > div > span {
  display: flex;
  cursor: pointer;
}

.reg__manager > button {
  height: 45px;
  border-radius: 8px;
  background: #0c6b60;
  border: none;
  cursor: pointer;
  padding: 0 34px;

  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
}

.reg__manager > a {
  color: #a2a2a2;
  font-size: 12px;
  font-weight: 400;
  text-decoration-line: underline;
}

.reg__organization {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 14px;
}

.reg__organization > input {
  width: 100%;
  height: 45px;
  border-radius: 8px;
  border: 1px solid var(--Border, #dde1eb);
  background: var(--White, #fff);
  padding: 0 16px;
  outline: none;

  color: #434343;
  font-size: 16px;
  font-weight: 500;
}

.reg__organization input::placeholder {
  color: var(--Placeholder, #b2bac6);
}

.reg__organization > div {
  width: calc((100% - 30px) / 2);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.reg__organization > div > input {
  width: 100%;
  height: 45px;
  border-radius: 8px;
  border: 1px solid var(--Border, #dde1eb);
  background: var(--White, #fff);
  padding: 0 16px;
  outline: none;

  color: #434343;
  font-size: 16px;
  font-weight: 500;
}

.reg__organization > div > div {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  gap: 10px;

  border-radius: 8px;
  border: 1px solid var(--Border, #dde1eb);
  background: var(--White, #fff);
  padding: 0 16px;
}

.reg__organization > div > div input {
  flex: 1 1;
  height: 100%;
  color: #434343;
  font-size: 16px;
  font-weight: 500;
}

.reg__organization > div > div input::placeholder {
  color: var(--Placeholder, #b2bac6);
}

.reg__organization > div > div > span {
  display: flex;
  cursor: pointer;
}

.login__form__registration .reg__actions {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.login__form__registration .reg__actions > button {
  height: 45px;
  border-radius: 8px;
  background: #0c6b60;
  border: none;
  cursor: pointer;
  padding: 0 34px;

  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
}

.login__form__registration .reg__actions > a {
  color: #a2a2a2;
  font-size: 12px;
  font-weight: 400;
  text-decoration-line: underline;
  padding-left: 20px;
}

/* ============= Comercial  ============= */
.login__form__commercial {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 0;
}

.login__form__commercial > h1 {
  color: #777f87;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
}

.login__form__commercial > p {
  color: #434343;
  text-align: justify;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}

@media (max-width: 1024px) {
  .login__container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .login__form__login {
    max-width: 540px;
    width: 100%;
  }

  .login__form__registration {
    max-width: 540px;
    width: 100%;
  }

  .reg__organization > div {
    width: 100%;
  }

  .reg__actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
}

@media (max-width: 768px) {
  .login__form__login > h1 {
    font-size: 18px;
  }

  .login__form__login input {
    font-size: 12px;
  }

  .login__form__registration > h1 {
    font-size: 18px;
  }

  .login__form__registration input {
    font-size: 12px;
  }

  .login__form__commercial > h1 {
    font-size: 18px;
  }

  .login__form__commercial > p {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/login.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE,UAAU;EACV,gBAAgB;EAChB,sDAAsD;EACtD,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;;EAEb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;;EAEf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,sDAAsD;EACtD,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,aAAa;;EAEb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;;EAEZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;;EAEf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,aAAa;;EAEb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,aAAa;;EAEb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;;EAEf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".login__container {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 30px;\n  padding: 5% 0;\n}\n\n/* ============= Login Form ============= */\n.login__form__login {\n  width: 40%;\n  background: #fff;\n  box-shadow: 0px 0px 73.6px 0px rgba(42, 77, 114, 0.19);\n  border-radius: 30px;\n  padding: 57px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  border: 2px solid transparent;\n  transition: all 0.15s ease-in-out;\n}\n\n.login__form__login:focus-within {\n  border: 2px solid #0c6b60;\n}\n\n.login__form__login > h1 {\n  inline-size: 100%;\n  color: #777f87;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 600;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.login__form__login > div {\n  width: 100%;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid var(--Border, #dde1eb);\n  background: var(--White, #fff);\n  overflow: hidden;\n  padding: 0 16px;\n}\n\n.login__form__login > div > input {\n  flex: 1;\n  height: 100%;\n  border: none;\n  outline: none;\n\n  color: #434343;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.login__form__login > div > input::placeholder {\n  color: var(--Placeholder, #b2bac6);\n}\n\n.login__form__login > div > span {\n  display: flex;\n  cursor: pointer;\n}\n\n.login__form__login > div > span > svg {\n  font-size: 18px;\n}\n\n.login__form__login > button {\n  width: 166px;\n  height: 45px;\n  border-radius: 8px;\n  background: #0c6b60;\n  border: none;\n  cursor: pointer;\n\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.login__form__login > a {\n  color: #a2a2a2;\n  font-size: 12px;\n  font-weight: 400;\n  text-decoration-line: underline;\n}\n\n/* ========== Registration form ============ */\n.login__form__registration {\n  width: calc(60% - 30px);\n  border-radius: 30px;\n  border: 2px solid transparent;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  box-shadow: 0px 0px 73.6px 0px rgba(42, 77, 114, 0.19);\n  transition: all 0.15s ease-in-out;\n}\n\n.login__form__registration:focus-within {\n  border: 2px solid #0c6b60;\n}\n\n.login__form__registration > h1 {\n  color: #777f87;\n  font-size: 24px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.login__form__registration__actions {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 30px;\n}\n\n.login__form__registration__actions > label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.login__form__registration__actions > label > b {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 1.2px solid var(--Gray, #a0a8b5);\n  background: var(--White, #fff);\n}\n\n.login__form__registration__actions > label > input:checked + b {\n  border: 5px solid #0c6b60;\n}\n\n.reg__manager {\n  max-width: 300px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n}\n\n.reg__manager > div {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n}\n\n.reg__manager > :where(input, div) {\n  width: 100%;\n  height: 45px;\n  border-radius: 8px;\n  border: 1px solid var(--Border, #dde1eb);\n  background: var(--White, #fff);\n  padding: 0 16px;\n  outline: none;\n\n  color: #434343;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.reg__manager > input::placeholder {\n  color: var(--Placeholder, #b2bac6);\n}\n\n.reg__manager > div {\n  display: flex;\n  align-items: center;\n}\n\n.reg__manager > div > input {\n  flex: 1;\n  height: 100%;\n  border: none;\n\n  color: #434343;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.reg__manager > div > input::placeholder {\n  color: var(--Placeholder, #b2bac6);\n}\n\n.reg__manager > div > span {\n  display: flex;\n  cursor: pointer;\n}\n\n.reg__manager > button {\n  height: 45px;\n  border-radius: 8px;\n  background: #0c6b60;\n  border: none;\n  cursor: pointer;\n  padding: 0 34px;\n\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.reg__manager > a {\n  color: #a2a2a2;\n  font-size: 12px;\n  font-weight: 400;\n  text-decoration-line: underline;\n}\n\n.reg__organization {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n.reg__organization > input {\n  width: 100%;\n  height: 45px;\n  border-radius: 8px;\n  border: 1px solid var(--Border, #dde1eb);\n  background: var(--White, #fff);\n  padding: 0 16px;\n  outline: none;\n\n  color: #434343;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.reg__organization input::placeholder {\n  color: var(--Placeholder, #b2bac6);\n}\n\n.reg__organization > div {\n  width: calc((100% - 30px) / 2);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.reg__organization > div > input {\n  width: 100%;\n  height: 45px;\n  border-radius: 8px;\n  border: 1px solid var(--Border, #dde1eb);\n  background: var(--White, #fff);\n  padding: 0 16px;\n  outline: none;\n\n  color: #434343;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.reg__organization > div > div {\n  width: 100%;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  border-radius: 8px;\n  border: 1px solid var(--Border, #dde1eb);\n  background: var(--White, #fff);\n  padding: 0 16px;\n}\n\n.reg__organization > div > div input {\n  flex: 1;\n  height: 100%;\n  color: #434343;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.reg__organization > div > div input::placeholder {\n  color: var(--Placeholder, #b2bac6);\n}\n\n.reg__organization > div > div > span {\n  display: flex;\n  cursor: pointer;\n}\n\n.login__form__registration .reg__actions {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.login__form__registration .reg__actions > button {\n  height: 45px;\n  border-radius: 8px;\n  background: #0c6b60;\n  border: none;\n  cursor: pointer;\n  padding: 0 34px;\n\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.login__form__registration .reg__actions > a {\n  color: #a2a2a2;\n  font-size: 12px;\n  font-weight: 400;\n  text-decoration-line: underline;\n  padding-left: 20px;\n}\n\n/* ============= Comercial  ============= */\n.login__form__commercial {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 20px 0;\n}\n\n.login__form__commercial > h1 {\n  color: #777f87;\n  font-size: 24px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.login__form__commercial > p {\n  color: #434343;\n  text-align: justify;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 150%;\n}\n\n@media (max-width: 1024px) {\n  .login__container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .login__form__login {\n    max-width: 540px;\n    width: 100%;\n  }\n\n  .login__form__registration {\n    max-width: 540px;\n    width: 100%;\n  }\n\n  .reg__organization > div {\n    width: 100%;\n  }\n\n  .reg__actions {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .login__form__login > h1 {\n    font-size: 18px;\n  }\n\n  .login__form__login input {\n    font-size: 12px;\n  }\n\n  .login__form__registration > h1 {\n    font-size: 18px;\n  }\n\n  .login__form__registration input {\n    font-size: 12px;\n  }\n\n  .login__form__commercial > h1 {\n    font-size: 18px;\n  }\n\n  .login__form__commercial > p {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
